import { VuexModule, Module, Action, Mutation, getModule } from 'vuex-module-decorators'
import store from '@/store'

export interface IDeviceItems2 {
    myDeviceItems2:Array<object>
}

@Module({ dynamic: true, store, name: 'store_deviceitems2' })
class DeviceItems2 extends VuexModule implements IDeviceItems2 {

    public myDeviceItems2 = [];

    @Mutation
    public SetDeviceItemsState(state) {
        this.myDeviceItems2 = state;
    }

}

export const DeviceItems2Module = getModule(DeviceItems2)
